<script>
  import { Smile, Frown, Meh } from 'lucide-svelte'
  import Tooltip from '@components/general/tooltip.svelte'
  import { titleCase, cn } from '@lib/utils'

  let { sentiment, showText = true, hint, class: className, fallback = "-" } = $props()

  let Icon = $derived(sentiment === "positive" ? Smile : sentiment === "negative" ? Frown : Meh)

  let iconClass = $derived(sentiment === "positive" ? "text-green-500" : sentiment === "negative" ? "text-red-500" : "text-gray-500")
</script>

{#if sentiment}
  <Tooltip {hint}>
    <div class={cn("flex items-center gap-2", className)}>
      {#if showText}
        <span>{titleCase(sentiment)}</span>
      {/if}
      <Icon size={16} class={iconClass} />
    </div>
  </Tooltip>
{:else}
  <span>{fallback}</span>
{/if}
